import { Banknote, CreditCard, FileText, Landmark, Trash2, Wallet } from 'lucide-react';
import CompactInputField from '../../../../components/Forms/Input/CompactInputField';

const METHOD_ICONS: Record<string, typeof Banknote> = {
  '01': Banknote,
  '02': CreditCard,
  '03': CreditCard,
  '04': FileText,
  '05': Landmark,
  '14': Landmark,
};

const PaymentItemCard = ({ item, onUpdate, onRemove }) => {
  const isCash = item.code === '01';
  const MethodIcon = METHOD_ICONS[item.code] || Wallet;

  return (
    <tr className="border-b border-stroke last:border-0 dark:border-strokedark">
      {/* 🔹 Método */}
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-success/10 text-success">
            <MethodIcon className="h-4 w-4" />
          </span>
          <span className="truncate text-sm font-medium text-black dark:text-white">
            {item.methodName}
          </span>
        </div>
      </td>

      {/* 🔹 Monto */}
      <td className="px-4 py-3">
        <CompactInputField
          name="amount"
          type="number"
          iconKey="dollar"
          value={item.amount ?? ''}
          onChange={(e) => {
            const value = e.target.value;

            onUpdate(item.id, {
              amount: value === '' ? '' : Number(value),
            });
          }}
          placeholder="0.00"
          min={0}
        />
      </td>

      {/* 🔹 Referencia */}
      <td className="px-4 py-3">
        {!isCash ? (
          <CompactInputField
            name="reference"
            type="text"
            iconKey="payment"
            value={item.reference ?? ''}
            onChange={(e) =>
              onUpdate(item.id, {
                reference: e.target.value,
              })
            }
            placeholder="Referencia"
          />
        ) : (
          <span className="text-xs text-body dark:text-bodydark2">—</span>
        )}
      </td>

      {/* 🔹 Eliminar */}
      <td className="px-4 py-3 text-right">
        <button
          type="button"
          onClick={() => onRemove(item.id)}
          aria-label="Eliminar método de pago"
          className="rounded-full p-2 text-danger transition hover:bg-danger/10"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </td>
    </tr>
  );
};

export default PaymentItemCard;
